const sessions =
{
    description : 'Voici l\'ensemble des informations sur les sessions actives et non expirées récemment enregistrées pour ce compte sur ce terminal ou d\'autres terminaux.' ,
    revokeAll   : 'Déconnecter toutes les sessions'
};

export default sessions ;